import { render, staticRenderFns } from "./termsofservice.vue?vue&type=template&id=305518da&"
import script from "./termsofservice.vue?vue&type=script&lang=js&"
export * from "./termsofservice.vue?vue&type=script&lang=js&"
import style0 from "./termsofservice.vue?vue&type=style&index=0&id=305518da&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TermsOfServiceContent: require('/opt/atlassian/pipelines/agent/build/components/TermsOfServiceContent.vue').default})
